import Result from 'antd-mobile/lib/result';
export default Result;



// WEBPACK FOOTER //
// ./components/result/index.tsx